import { MediaResource } from '@brightmls/nextgen.lae.flc';
import { ProcessedImageData } from '../../ImageEditDialog';
import { ImageConfig } from '../../utils/imageUtils';
import { Logger } from '../../../../../utils/logger';

export const MEDIA_TIMEOUT = 30000;

export interface MediaMetadata {
  name: string;
  type: string;
  category: string;
  description?: string | null;
  sizeDescription?: string;
  shortDescription?: string;
  visibility?: string;
  itemNumber: number;
  displayOrder: number;
  size: number;
  file?: File;
}

// Define more granular upload stages for better progress visualization
export type UploadStage =
  | 'preparing'
  | 'reading'
  | 'uploading'
  | 'sending'
  | 'processing'
  | 'complete'
  | 'error'
  | string;

export interface UploadFileStatus {
  name: string;
  previewUrl: string;
  stage: UploadStage;
  progress: number; // 0-100
  error?: string;
  statusText?: string; // More detailed status message
}

export interface MediaUploadState {
  isLoading?: boolean;
  progress: number;
  previewUrl: string;
  error?: Error;
}

export interface MediaUploadResult {
  MED_VW_KEY: string;
  MEDIA_URL_MEDIUM?: string;
  CWAMediaProcessingStatus?: string;
  [key: string]: any;
}

export interface ListingDetails {
  CWAPropertyType: string;
  CWALISKey: string;
  CWACounty: string;
}

export interface ReplaceMediaMetadata {
  processedImageData: ProcessedImageData;
  mediaMetadata: MediaMetadata;
  mediaRecord: any;
}

export interface ReplaceFileStatus {
  mediaKey: string;
  name: string;
  stage: UploadStage;
  progress: number;
  error?: string;
  statusText?: string;
}

export interface BatchReplaceResult {
  results: Array<{
    mediaKey: string;
    success: boolean;
    error?: Error;
    result?: any;
  }>;
  totalCount: number;
  successCount: number;
  failureCount: number;
}

export interface UseMediaUploadOptions {
  listingKey: string;
  listingDetails: ListingDetails;
  onUploadComplete?: (result: MediaUploadResult) => void;
  onBatchComplete?: () => void;
  onUploadError?: (error: Error, metadata: MediaMetadata) => void;
  onReplaceComplete?: (result: MediaResource) => void;
  onReplaceBatchComplete?: () => void;
  onReplaceError?: (error: Error, imageData: ProcessedImageData) => void;
  pollInterval?: number;
  maxPollAttempts?: number;
  imageConfig?: ImageConfig;
  logger?: Logger;
  maxShadowFailures?: number;
  onMimeTypeError?: (
    error: Error,
    operation: 'create' | 'upload' | 'replace',
  ) => void;
}
